import { BackendModel, BackendService } from "../core/backend.service";

export class RangoFecha extends BackendModel {
    fechaDesde: string;
    fechaHasta: string;
    habil: boolean;

  constructor(protected backendService: BackendService, model?: RangoFecha) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/rango-fecha.model.ts